import React from "react";

export default function NotFound() {
  return <p style={{ color: "red" }}>Not found</p>;
}
